import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Send, User, Bot, MapPin, DollarSign, School, ArrowLeft, RefreshCcw, Briefcase, GraduationCap, Edit2, Wallet, Phone, MessageCircle, Star, Sparkles, X } from 'lucide-react';

// --- DATA FROM UPLOADED EXCEL SHEET (Complete List) ---
const universityDatabase = [
  // Georgia (6 years)
  { id: 'g1', country: "Georgia", name: "Caucasus University", fees: "6000", currency: "USD", duration: "6", medium: "English", slab: "30-35 Lakhs" },
  { id: 'g2', country: "Georgia", name: "Tbilisi State Medical University (American Curriculum)", fees: "13500", currency: "USD", duration: "6", medium: "English", slab: "70-75 Lakhs" },
  { id: 'g3', country: "Georgia", name: "Tbilisi State Medical University (European Curriculum)", fees: "8000", currency: "USD", duration: "6", medium: "English", slab: "40-45 Lakhs" },
  { id: 'g4', country: "Georgia", name: "International Black Sea University", fees: "4500+400", currency: "USD", duration: "6", medium: "English", slab: "25-30 Lakhs" },
  { id: 'g5', country: "Georgia", name: "East West University", fees: "3900+400", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'g6', country: "Georgia", name: "Tbilisi Medical Academy", fees: "7000", currency: "USD", duration: "6", medium: "English", slab: "35-40 Lakhs" },
  { id: 'g7', country: "Georgia", name: "University of Georgia", fees: "6500", currency: "USD", duration: "6", medium: "English", slab: "30-35 Lakhs" },
  { id: 'g8', country: "Georgia", name: "European University", fees: "5500", currency: "USD", duration: "6", medium: "English", slab: "25-30 Lakhs" },
  { id: 'g9', country: "Georgia", name: "Georgian National University SEU", fees: "5900+400", currency: "USD", duration: "6", medium: "English", slab: "30-35 Lakhs" },
  { id: 'g10', country: "Georgia", name: "Alte University", fees: "5500", currency: "USD", duration: "6", medium: "English", slab: "25-30 Lakhs" },

  // Uzbekistan (6 years)
  { id: 'u1', country: "Uzbekistan", name: "Tashkent Medical Academy", fees: "3500", currency: "USD", duration: "6", medium: "English", slab: "15-20 Lakhs" },
  { id: 'u2', country: "Uzbekistan", name: "Samarkand State Medical University", fees: "3850", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'u3', country: "Uzbekistan", name: "Bukhara State Medical Institute", fees: "3200", currency: "USD", duration: "6", medium: "English", slab: "15-20 Lakhs" },

  // Russia (6 years)
  { id: 'r1', country: "Russia", name: "Ivanovo State Medical Academy", fees: "285000", currency: "RUB", duration: "6", medium: "English", slab: "15-20 Lakhs" },
  { id: 'r2', country: "Russia", name: "Kemerovo State Medical University", fees: "295000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r3', country: "Russia", name: "Kemerovo State University", fees: "277000", currency: "RUB", duration: "6", medium: "English", slab: "15-20 Lakhs" },
  { id: 'r4', country: "Russia", name: "Ural State Medical University", fees: "300000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r5', country: "Russia", name: "Yaroslavl State Medical University", fees: "350000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r6', country: "Russia", name: "Bashkir State Medical University", fees: "399120", currency: "RUB", duration: "6", medium: "English", slab: "25-30 Lakhs" },
  { id: 'r7', country: "Russia", name: "North Ossetian State Medical Academy", fees: "310000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r8', country: "Russia", name: "Far Eastern Federal University", fees: "495000", currency: "RUB", duration: "6", medium: "English", slab: "30-35 Lakhs" },
  { id: 'r9', country: "Russia", name: "Novosibirsk State University", fees: "539500", currency: "RUB", duration: "6", medium: "English", slab: "35-40 Lakhs" },
  { id: 'r10', country: "Russia", name: "Crimea Federal University", fees: "330000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r11', country: "Russia", name: "Lobachevsky State University", fees: "410000", currency: "RUB", duration: "6", medium: "English", slab: "25-30 Lakhs" },
  { id: 'r12', country: "Russia", name: "Omsk State University", fees: "330000", currency: "RUB", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'r13', country: "Russia", name: "Tver State Medical University", fees: "430000", currency: "RUB", duration: "6", medium: "English", slab: "25-30 Lakhs" },

  // Egypt (7 years)
  { id: 'e1', country: "Egypt", name: "Cairo University", fees: "8000", currency: "USD", duration: "7", medium: "English", slab: "50-55 Lakhs" },
  { id: 'e2', country: "Egypt", name: "Mansoura University", fees: "8000", currency: "USD", duration: "7", medium: "English", slab: "50-55 Lakhs" },
  { id: 'e3', country: "Egypt", name: "Ain Shams University", fees: "8000", currency: "USD", duration: "7", medium: "English", slab: "50-55 Lakhs" },
  { id: 'e4', country: "Egypt", name: "Assiut University", fees: "8000", currency: "USD", duration: "7", medium: "English", slab: "50-55 Lakhs" },
  { id: 'e5', country: "Egypt", name: "Alexandria University", fees: "8000", currency: "USD", duration: "7", medium: "English", slab: "50-55 Lakhs" },
  { id: 'e6', country: "Egypt", name: "Nahda University", fees: "5000", currency: "USD", duration: "7", medium: "English", slab: "30-35 Lakhs" },

  // Armenia (6 years)
  { id: 'a1', country: "Armenia", name: "University of Traditional Medicine", fees: "4500", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },

  // Bulgaria (6 years)
  { id: 'b1', country: "Bulgaria", name: "Varna Medical University", fees: "10000", currency: "Euro", duration: "6", medium: "English", slab: "60-65 Lakhs" },
  { id: 'b2', country: "Bulgaria", name: "Medical University of Plovdiv", fees: "10000", currency: "Euro", duration: "6", medium: "English", slab: "60-65 Lakhs" },
  { id: 'b3', country: "Bulgaria", name: "Medical University of Sofia", fees: "10000", currency: "Euro", duration: "6", medium: "English", slab: "60-65 Lakhs" },
  { id: 'b4', country: "Bulgaria", name: "Pleven State Medical University", fees: "9000", currency: "Euro", duration: "6", medium: "English", slab: "50-55 Lakhs" },
  { id: 'b5', country: "Bulgaria", name: "Trakia University", fees: "8000", currency: "Euro", duration: "6", medium: "English", slab: "45-50 Lakhs" },

  // Hungary (6 years)
  { id: 'h1', country: "Hungary", name: "University of Debrecen", fees: "16900", currency: "USD", duration: "6", medium: "English", slab: "90-95 Lakhs" },

  // Moldova (7 years)
  { id: 'm1', country: "Moldova", name: "Nicolae Testemitanu State University", fees: "6000", currency: "Euro", duration: "7", medium: "English", slab: "40-45 Lakhs" },

  // Kazakhstan (6 years)
  { id: 'k1', country: "Kazakhstan", name: "Caspian International School of Medicine", fees: "4500", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },

  // Kyrgyzstan (6 years)
  { id: 'ky1', country: "Kyrgyzstan", name: "Jalal-Abad International University", fees: "3200", currency: "USD", duration: "6", medium: "English", slab: "15-20 Lakhs" },
  { id: 'ky2', country: "Kyrgyzstan", name: "Jalal-Abad State University", fees: "4500", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },
  { id: 'ky3', country: "Kyrgyzstan", name: "Osh State Medical University", fees: "4000", currency: "USD", duration: "6", medium: "English", slab: "20-25 Lakhs" },

  // Azerbaijan (6 years)
  { id: 'az1', country: "Azerbaijan", name: "Azerbaijan Medical University", fees: "6750", currency: "USD", duration: "6", medium: "English", slab: "35-40 Lakhs" },
];

const DYNAMIC_SLABS = [...new Set(universityDatabase.map(u => u.slab))].sort((a, b) => {
  const numA = parseInt(a.split('-')[0]);
  const numB = parseInt(b.split('-')[0]);
  return numA - numB;
});

const GREETINGS = ["hi", "hello", "hey", "hii", "hellooo", "hola", "namaste", "namaskaram", "good morning", "good evening", "hlo"];

const countryCodes = {
  "Georgia": "ge", "Uzbekistan": "uz", "Russia": "ru", "Egypt": "eg", "Armenia": "am",
  "Bulgaria": "bg", "Hungary": "hu", "Moldova": "md", "Kazakhstan": "kz", "Kyrgyzstan": "kg", "Azerbaijan": "az"
};

const normalize = (str) => str.replace(/\s+/g, '').toLowerCase();

const universityDescriptions = {
  "Caucasus University": "Caucasus University, located in Tbilisi, offers a 6-year English-medium MD program recognized by WHO, ECFMG (USA), NMC India, and listed in World Directory of Medical Schools (WDOMS). The American-style curriculum prepares students for USMLE, PLAB, and FMGE.",
  "Tbilisi State Medical University (American Curriculum)": "The top-ranked and oldest medical university in Georgia. Graduates are eligible for USMLE, PLAB, and direct residency in the USA/Canada/Europe.",
  "Tashkent Medical Academy": "Founded in 1920, Uzbekistan's oldest government medical university. Highly popular among Indian students for its high-quality education and affordable fees.",
  "Ivanovo State Medical Academy": "Established in 1930, one of Russia's most prestigious medical academies with a high FMGE success rate.",
  // ... (Other descriptions omitted for brevity in this snippet)
};

const SHARED_DESCRIPTIONS = {
  "Uzbekistan": "Government universities offering highly affordable 6-year English-medium MBBS programs.",
  "Russia": "Prestigious Russian government medical universities offering 6-year English-medium MD programs.",
  "Egypt": "Among the oldest and most reputed medical universities in the Middle East.",
  "Bulgaria": "Top European medical universities offering 6-year English-medium MD programs fully recognized across the EU.",
  "Kyrgyzstan": "Government universities offering low-cost, WHO & NMC-recognized 6-year English-medium MBBS programs."
};

// --- HELPER COMPONENTS ---

const TypingIndicator = () => (
  <div className="flex space-x-1 p-2 bg-red-50 rounded-xl rounded-tl-none w-fit items-center mb-2 ml-10">
    <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
    <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
    <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
  </div>
);

const ChatMessage = ({ msg }) => {
  const isBot = msg.sender === 'bot';
  return (
    <div className={`flex w-full ${isBot ? 'justify-start' : 'justify-end'} mb-4 animate-fade-in-up`}>
      <div className={`flex max-w-[95%] md:max-w-[85%] ${isBot ? 'flex-row' : 'flex-row-reverse'}`}>
        <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center mt-1 ${isBot ? 'bg-red-600 text-white mr-2' : 'bg-gray-200 ml-2'}`}>
          {isBot ? <Bot size={18} /> : <User size={18} />}
        </div>
        <div className={`p-3 rounded-2xl text-sm md:text-base shadow-sm ${
          isBot ? 'bg-white border border-red-100 text-gray-800 rounded-tl-none' : 'bg-red-600 text-white rounded-tr-none'
        }`}>
          {msg.text && (
            typeof msg.text === 'string' 
              ? <div className="whitespace-pre-line leading-relaxed">{msg.text}</div>
              : <div className="leading-relaxed">{msg.text}</div>
          )}
          {msg.customRender}
        </div>
      </div>
    </div>
  );
};

// --- MAIN APP COMPONENT ---

export default function App() {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [step, setStep] = useState(0); 
  
  // Initialize with a unique Session ID to update the same row in Google Sheets
  const [userData, setUserData] = useState({
    sessionId: useMemo(() => `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`, []),
    name: "",
    budgetSlab: "", 
    country: "",
    selectedUni: null,
    phone: "",
    city: "",
    education: "",
    userType: ""
  });
  
  const messagesEndRef = useRef(null);
  const lastSubmittedData = useRef("");

  useEffect(() => {
    const timer = setTimeout(() => {
        if (messages.length > 1 || (isTyping && messages.length > 0)) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, 100);
    return () => clearTimeout(timer);
  }, [messages, isTyping]);

  useEffect(() => {
    addBotMessage(
      "Namaskaram! 🙏 Welcome to Ceeco International.\n\nI am Ceeco AI, your personal MBBS study abroad assistant. I'm here to help you find the perfect university.\n\nOne quick question before we start: Are you a parent or a student?",
      <div className="flex flex-wrap gap-2 mt-3">
         <button onClick={() => handleUserTypeSelect('student')} className="bg-white border border-red-200 text-red-700 font-semibold py-2 px-4 rounded-lg text-sm hover:bg-red-50 hover:border-red-400 transition-all flex-grow">I am a Student</button>
         <button onClick={() => handleUserTypeSelect('parent')} className="bg-white border border-red-200 text-red-700 font-semibold py-2 px-4 rounded-lg text-sm hover:bg-red-50 hover:border-red-400 transition-all flex-grow">I am a Parent</button>
      </div>
    );
  }, []);

  // --- REAL-TIME SYNC LOGIC ---
  // This useEffect fires every time ANY userData field changes.
  useEffect(() => {
    // Only submit if at least the User Type is selected (start of conversation)
    if (!userData.userType) return;

    const syncToSheets = async () => {
      const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbx-1fx6WOkfxtTGi3xGTeWwyYp3O4m806S-39nEeGcZDjyJvy3Q87umTulCQ52Aw1At/exec";

      const payload = {
        sessionId: userData.sessionId, // CRITICAL: Used by Apps Script to update same row
        timestamp: new Date().toLocaleString(),
        userType: userData.userType || "",
        name: userData.name || "",
        phone: userData.phone || "",
        city: userData.city || "",
        education: userData.education || "",
        budgetSlab: userData.budgetSlab || "",
        country: userData.country || "",
        university: userData.selectedUni ? userData.selectedUni.name : ""
      };
      
      const payloadString = JSON.stringify(payload);
      if (payloadString === lastSubmittedData.current) return;

      try {
        await fetch(SCRIPT_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: payloadString
        });
        lastSubmittedData.current = payloadString;
        console.log("Sheet synced:", payload);
      } catch (err) {
        console.error("Sync failed:", err);
      }
    };

    // Delay slightly to ensure state is fully settled
    const timeout = setTimeout(syncToSheets, 500);
    return () => clearTimeout(timeout);
  }, [userData]);

  const addBotMessage = (text, customRender = null) => {
    setIsTyping(true);
    setTimeout(() => {
      setMessages(prev => [...prev, { sender: 'bot', text, customRender }]);
      setIsTyping(false);
    }, 800 + Math.random() * 500);
  };

  const addUserMessage = (text) => {
    setMessages(prev => [...prev, { sender: 'user', text }]);
  };

  const handleSendMessage = () => {
    if (!userInput.trim()) return;
    const text = userInput;
    setUserInput("");
    addUserMessage(text);
    processUserResponse(text);
  };

  const processUserResponse = (text) => {
    const lowerText = text.toLowerCase().trim();

    if (step === 0) {
        addBotMessage("Please select whether you are a Student or a Parent using the buttons above to proceed.");
        return;
    }

    if (step === 1) {
      if (GREETINGS.includes(lowerText)) {
        addBotMessage("Hello! 👋 Please tell me your actual name.");
        return;
      }
      setUserData(prev => ({ ...prev, name: text }));
      setStep(5);
      addBotMessage(`Nice to meet you, ${text}! 😊\n\nCould you please share your Phone Number?`);
      return;
    }

    if (step === 5) {
      const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
      if (!phoneRegex.test(text.replace(/\s/g, ''))) {
        addBotMessage("❌ Please share a valid 10-digit mobile number.");
        return;
      }
      setUserData(prev => ({ ...prev, phone: text }));
      setStep(6);
      addBotMessage("Thank you! ✅\n\nWhich city are you currently located in?");
      return;
    }

    if (step === 6) {
      setUserData(prev => ({ ...prev, city: text }));
      setStep(7);
      addBotMessage(
          "Noted. And finally, what is your current educational status?",
          <div className="flex flex-wrap gap-2 mt-3">
            {["10th", "11th", "12th pursuing", "Neet Preparation"].map(s => (
              <button key={s} onClick={() => handleEducationSelect(s)} className="bg-red-50 text-red-700 border border-red-200 px-3 py-2 rounded-lg text-xs font-medium hover:bg-red-600 hover:text-white transition-all flex-grow">{s}</button>
            ))}
          </div>
      );
      return;
    }
  };

  const handleUserTypeSelect = (type) => {
      setUserData(prev => ({ ...prev, userType: type }));
      addUserMessage(type === 'student' ? "I am a Student" : "I am a Parent");
      setStep(1);
      setTimeout(() => addBotMessage("Great! May I know your name, please?"), 600);
  };

  const handleEducationSelect = (status) => {
    setUserData(prev => ({ ...prev, education: status }));
    addUserMessage(status);
    setStep(2);
    setTimeout(() => {
        addBotMessage("Great! Now, please select your total tuition fee budget in INR",
          <div className="flex flex-wrap gap-2 mt-3">
               {DYNAMIC_SLABS.map((slab) => (
                   <button key={slab} onClick={() => handleBudgetSelect(slab)} className="bg-white border border-red-200 text-red-700 font-semibold py-2 px-4 rounded-full shadow-sm hover:bg-red-50 hover:border-red-400 transition-all text-sm mb-1">{slab}</button>
               ))}
          </div>
        );
    }, 600);
  };

  const handleBudgetSelect = (slab) => {
    setUserData(prev => ({ ...prev, budgetSlab: slab }));
    addUserMessage(slab);
    setStep(3);
    const targetSlab = normalize(slab);
    const validCountries = Array.from(new Set(universityDatabase.filter(u => normalize(u.slab) === targetSlab).map(u => u.country)));
    
    addBotMessage("Destinations based on your budget. Select a country:", 
      <div className="flex flex-wrap gap-2 mt-3 w-full">
        {validCountries.map(c => (
          <button key={c} onClick={() => handleCountrySelect(c, slab)} className="bg-red-100 border border-red-200 text-red-800 font-bold py-2 px-4 rounded-full shadow-sm hover:bg-red-200 transition-all flex items-center mb-2">
            <img src={`https://flagcdn.com/48x36/${countryCodes[c]}.png`} alt={c} className="w-6 h-4 object-cover rounded-sm shadow-sm mr-2" /> {c}
          </button>
        ))}
      </div>
    );
  };

  const handleCountrySelect = (country, slab) => {
    setUserData(prev => ({ ...prev, country: country }));
    addUserMessage(country);
    setStep(4);
    const targetSlab = normalize(slab);
    const universities = universityDatabase.filter(u => u.country === country && normalize(u.slab) === targetSlab);
    
    setTimeout(() => {
        addBotMessage(<span className="font-semibold text-gray-800">Top Recommended Universities in {country}:</span>, 
            <div className="space-y-4 mt-4 w-full flex flex-col items-center">
                {universities.map(uni => (
                    <div key={uni.id} className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-3 w-full max-w-sm">
                        <div className="bg-red-50 p-4 text-center border-b border-red-100">
                            <h3 className="font-bold text-lg text-gray-900 leading-tight mb-1">{uni.name}</h3>
                            <div className="flex items-center justify-center space-x-2 text-sm text-gray-600">
                                <img src={`https://flagcdn.com/48x36/${countryCodes[uni.country]}.png`} alt={uni.country} className="w-6 h-4 object-cover rounded-sm shadow-sm" />
                                <span className="font-medium uppercase tracking-wide text-xs">{uni.country}</span>
                            </div>
                        </div>
                        <div className="p-4 grid grid-cols-2 gap-4 text-sm bg-white">
                            <div className="flex flex-col items-center text-center">
                                <GraduationCap className="text-red-500 mb-1" size={20} />
                                <span className="text-[10px] text-gray-400 uppercase font-semibold">Duration</span>
                                <span className="font-bold text-gray-800">{uni.duration} Yrs</span>
                            </div>
                            <div className="flex flex-col items-center text-center">
                                <DollarSign className="text-red-500 mb-1" size={20} />
                                <span className="text-[10px] text-gray-400 uppercase font-semibold">Fees</span>
                                <span className="font-bold text-gray-800">{uni.fees} {uni.currency}/yr</span>
                            </div>
                        </div>
                        <div className="p-4 pt-0">
                            <button onClick={() => handleSelectUni(uni)} className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 rounded-xl shadow-lg transition-all transform active:scale-95">Get More Details</button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }, 600);
  };

  const handleSelectUni = (uni) => {
    setUserData(prev => ({ ...prev, selectedUni: uni }));
    let description = universityDescriptions[uni.name] || SHARED_DESCRIPTIONS[uni.country] || "Contact for more info.";
    addBotMessage(description);
    setStep(9);
    setTimeout(() => {
         addBotMessage(
            <div className="space-y-2">
                <p>We have updated your interest for <strong>{uni.name}</strong>.</p>
                <p>Our team will contact you shortly!</p>
                <a href="https://wa.me/918137878027" target="_blank" rel="noopener noreferrer" className="mt-2 flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 px-6 rounded-xl font-bold shadow-md w-full">
                    Contact Us Now
                </a>
            </div>
         );
    }, 1200);
  };

  const handleBack = () => {
    if (step === 5) setStep(1);
    else if (step === 6) setStep(5);
    else if (step === 7) setStep(6);
    else if (step === 2) setStep(7);
    addBotMessage("Sure, let's go back and correct that.");
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50 font-sans">
      <style>{`
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in-up { animation: fadeInUp 0.4s ease-out forwards; }
      `}</style>
      <header className="bg-gradient-to-r from-red-700 to-red-600 text-white shadow-lg flex items-center justify-between fixed top-0 left-0 right-0 z-50 p-4">
        <div className="flex items-center space-x-2">
          <div className="bg-white p-1 rounded-full"><School className="text-red-600" size={24} /></div>
          <div>
            <h1 className="text-lg font-bold">Ceeco AI</h1>
            <p className="text-xs text-red-100">MBBS Study Abroad Expert</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
            <a href="tel:+918137878027" className="bg-white text-red-600 px-3 py-1.5 rounded-full text-xs font-bold flex items-center"><Phone size={14} className="mr-1" /> Call Now</a>
            <div className="flex items-center gap-1 bg-red-800 bg-opacity-50 px-2 py-1 rounded text-[10px]"><span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span> Online</div>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto p-4 pb-32 pt-24">
        {messages.map((msg, idx) => <ChatMessage key={idx} msg={msg} />)}
        {isTyping && <TypingIndicator />}
        <div ref={messagesEndRef} />
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-3 shadow-lg z-20">
        <div className="flex items-center gap-2">
          {step > 1 && step < 9 && (
            <button onClick={handleBack} className="p-3 text-gray-500 hover:bg-gray-100 rounded-full"><ArrowLeft size={20} /></button>
          )}
          <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
            placeholder={step === 5 ? "Enter Phone Number..." : (step === 6 ? "Enter City..." : "Type here...")}
            disabled={step === 0 || step === 2 || step === 3 || step === 4 || step === 7 || step === 9} 
            className="flex-1 bg-gray-100 rounded-full px-5 py-3 focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
          />
          <button onClick={handleSendMessage} disabled={!userInput.trim()} className={`p-3 rounded-full text-white ${userInput.trim() ? 'bg-red-600' : 'bg-gray-300'}`}>
            <Send size={20} />
          </button>
        </div>
        <p className="text-center text-[10px] text-gray-400 mt-2">Powered by Ceeco International</p>
      </div>
    </div>
  );
}
